
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';

@Component
export default class HighlightsField extends Vue {
  highlights: any = [];

  val: any = [];

  @Prop()
  readonly!: boolean;


  @Prop()
  value!: any;

  @Watch('value')
  watchValue() {
    if (this.value?.length > 0) {
      this.val = this.value;
    } else {
      this.val = [];
    }
  }

  breakDown(val: any) {
    const _a = [];
    for (const key in val) {
      if (key) {
        _a.push({
          value: Number(key),
          label: val[key],
        });
      }
    }
    return _a;
  }
  change(val: any) {
    console.log('val=>', this.val);
    if (this.val.includes(val)) {
      this.val = this.val.filter((item: any) => item !== val);
    } else {
      this.val.push(val);
    }
    this.$emit('update', this.val);
  }

  mounted() {
    const carFields = JSON.parse(localStorage.getItem('carFields') || '{}');
    const { highlights } = carFields;
    this.highlights = this.breakDown(highlights);
    this.watchValue();
  }
}
